import { useState, useEffect } from 'react';
import MUITable from '../../../Common/MUITable';
import { TableLoader } from "../../../Common/ShimmerLoader";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from 'react-toastify';
import 'jspdf-autotable';
import isGHMC from '../../../Common/helper/helpar';
import AddEditDepartmentModal from './AddEditDepartmentModal';
import ExportDepartment from './ExportDepartment';
import { StatusBadge } from "../../Rfid/utils/statusBadge";
import { sortActiveFirst } from "../../ComplaintManagement/utils/complaintListUtils";


// Get the token from localStorage
const getToken = () => {
    return localStorage.getItem("token");
};

export const getDepartments = async (departmentName, isActive) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}Attendance/GetAllDepartment`,
            {
                params: {
                    DepartmentName: departmentName,
                    IsActive: isActive
                },
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const addOrUpdateDepartment = async (data) => {
   const response = await axiosInstance.post(
    `${API_BASE_URL1}Attendance/AddAndUpdateDepartment`,
    data,
    {
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json"
        }
    }
);
    return response.data;
};

const Departments = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [departmentTableData, setDepartmentTableData] = useState([]);
    const [filterOriginalDepartmentData, setFilterOriginalDepartmentData] = useState([]);
    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [editDepartmentTableRow, setEditDepartmentTableRow] = useState(null);
    const [searchDepartment, setSearchDepartment] = useState("");
    const isProd = isGHMC();

const handleSaveDepartment = async (departmentData) => {
    setIsLoading(true);
    try {
        const result = await addOrUpdateDepartment(departmentData);
        const backendMessage = result?.message || result?.msg || "";
        const isFailure =
            result?.result === 0 ||
            result?.result === false ||
            result?.success === false ||
            /already exist/i.test(backendMessage);

        if (isFailure) {
            return {
                success: false,
                message: backendMessage || "Department already exists.",
                data: result,
            };
        }

        fetchDepartments();
        return { success: true, data: result, message: backendMessage };
    } catch (error) {
        const responseData = error?.response?.data;
        const errorMessage =
            (typeof responseData === "string" ? responseData : null) ||
            responseData?.message ||
            responseData?.msg ||
            error?.message ||
            "Something went wrong!";

        return { success: false, message: errorMessage };
    } finally {
        setIsLoading(false);
    }
};

const fetchDepartments = async (searchValue = searchDepartment) => {
    setIsLoading(true);
    try {
        const data = await getDepartments("", ""); // Load all for table search
        const rows = Array.isArray(data) ? data : (data?.data || data?.result || []);
        const sortedRows = sortActiveFirst(rows);
        setFilterOriginalDepartmentData(sortedRows);
        setDepartmentTableData(sortedRows);
    } catch (error) {
        console.error('Error loading departments:', error);
    } finally {
        setIsLoading(false);
    }
};
    
    useEffect(() => {
        fetchDepartments();
    }, []);

    const handleEdit = (row) => {
        setEditDepartmentTableRow(row);
        setShowAddEditModal(true);
    };

    const searchDepartmentHandler = (e) => {
        const term = e.target.value.toLowerCase();
        const data = filterOriginalDepartmentData.filter((item) =>
            item?.departmentName?.toLowerCase()?.includes(term)
        );
        setDepartmentTableData(data);
    };

    const columns = [
        {
            label: "Department Name",
            render: (row) => row.departmentName || "N/A",
        },
        {
  label: "Status",
  render: (row) => <StatusBadge isActive={row.isActive} compact />,
},
        {
            label: "Last Modified By",
            render: (row) => row.updatedByName || "N/A",
        },
        {
            label: "Action",
            render: (row) => (
                <button
                    title='Edit'
                    className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                    onClick={() => handleEdit(row)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            ),
        },
    ];

    return (
        <>
            <div className="content">
                <div className="page-content">

                    {/* ── Top Header Bar ── */}
                    <div className="dept-page-header">
                        {/* Left: title + subtitle */}
                        <div className="dept-title-block">
                            <h5 className="dept-page-title">All Department Information</h5>
                            <p className="dept-page-subtitle">
                                Manage, track, and maintain employee records across zones, wards,
                                departments, shifts, and KPI categories.
                            </p>
                        </div>

                        {/* Right: action buttons */}
                        <div className="dept-action-buttons">
                            <button
                                className="button-container"
                                onClick={() => { setEditDepartmentTableRow(null); setShowAddEditModal(true); }}
                            >
                                <i className="fa-solid fa-plus me-1 icon-container"></i>
                                Add Department
                            </button>
                            <ExportDepartment departmentTableData={departmentTableData} />
                        </div>
                    </div>

                    {/* ── Search / Filter Row ── */}
                    {/* <div className="dept-filter-row">
                        <div className="dept-search-group">
                            <label className="dept-search-label" style={{
                                display: "block",
                                textAlign: "left",
                                marginBottom: "5px",
                                fontWeight: "500"
                            }}>Search Department Name</label>
                            <input
                                type="text"
                                className="form-control dept-search-input"
                                placeholder="Enter Department Name"
                                value={searchDepartment}
                                onChange={(e) => setSearchDepartment(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && fetchDepartments()}
                            />
                        </div>

                        <div className="dept-filter-actions">
                           <button
                    className="btn dept-btn-apply"
                    onClick={() => fetchDepartments(searchDepartment)}
                >
                    APPLY FILTERS
                </button>
                           <button
                        className="btn dept-btn-reset"
                        onClick={() => {
                            setSearchDepartment("");
                            fetchDepartments("");
                        }}
                    >
                        RESET
                    </button>
                        </div>
                    </div> */}

                    <div className="row justify-content-between mt-2 mb-2">
                        <div className="col-md-3">
                            <div className="form-group">
                                <input
                                    placeholder="Search Department Name"
                                    type="text"
                                    className="form-control bg-white"
                                    onInput={searchDepartmentHandler}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ── Table Card ── */}
                    <div className="card shadow mt-3">
                        <div className="card-body">
                            <div className="top-header">
                                <span>Departments</span>
                            </div>
                            <MUITable loading={isLoading}
                                rows={departmentTableData}
                                columns={columns}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <AddEditDepartmentModal
                setDepartmentTableData={fetchDepartments}
                showAddEditModal={showAddEditModal}
                setShowAddEditModal={setShowAddEditModal}
                editDepartmentTableRow={editDepartmentTableRow}
                setEditDepartmentTableRow={setEditDepartmentTableRow}
                addDepartment={handleSaveDepartment}
                updateDepartment={handleSaveDepartment}
            />
            <ToastContainer />

            {/* ── Scoped Styles ── */}
            <style>{`
                /* ---- Page Header ---- */
                .dept-page-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 20px 0 12px 0;
                    flex-wrap: wrap;
                    gap: 12px;
                }

                .dept-title-block {
                    flex: 1;
                    min-width: 200px;
                    text-align: left;
                }

                .dept-page-title {
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: #1a1a2e;
                    margin: 0 0 3px 0;
                    text-align: left;
                }

                .dept-page-subtitle {
                    font-size: 0.8rem;
                    color: #6c757d;
                    margin: 0;
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 700px;
                }

                /* ---- Action Buttons (top-right) ---- */
                .dept-action-buttons {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-shrink: 0;
                }

                /* Override ExportDepartment child buttons to look like Image 2 */
                .dept-action-buttons button:not(.button-container),
                .dept-action-buttons a:not(.button-container) {
                    background-color: #fff !important;
                    color: #212529 !important;
                    border: 1px solid #ced4da !important;
                    border-radius: 6px !important;
                    padding: 7px 14px !important;
                    font-size: 0.875rem !important;
                    font-weight: 400 !important;
                    box-shadow: none !important;
                    white-space: nowrap;
                    transition: background 0.15s, border-color 0.15s;
                }

                .dept-action-buttons button:not(.button-container):hover,
                .dept-action-buttons a:not(.button-container):hover {
                    background-color: #f8f9fa !important;
                    border-color: #adb5bd !important;
                    color: #212529 !important;
                }

                /* ---- Filter / Search Row ---- */
                .dept-filter-row {
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;
                    gap: 16px;
                    padding: 14px 0 0 0;
                    flex-wrap: wrap;
                }

                .dept-search-group {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    flex: 1;
                    min-width: 200px;
                    max-width: 320px;
                }

                .dept-search-label {
                    font-size: 0.8rem;
                    font-weight: 500;
                    color: #495057;
                    margin-left: 0px;
                }

                .dept-search-input {
                    border: 1px solid #ced4da;
                    border-radius: 6px;
                    font-size: 0.875rem;
                    padding: 7px 12px;
                    height: 38px;
                    background-color: #fff;
                }

                .dept-search-input:focus {
                    border-color: #1a2e4a;
                    box-shadow: 0 0 0 2px rgba(26,46,74,0.12);
                    outline: none;
                }

                /* ---- Filter Action Buttons (bottom-right of filter row) ---- */
                .dept-filter-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-shrink: 0;
                }

                .dept-btn-apply {
                    background-color: #1a2e4a;
                    color: #fff;
                    border: none;
                    border-radius: 6px;
                    padding: 8px 20px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    letter-spacing: 0.4px;
                    transition: background 0.2s;
                    white-space: nowrap;
                }

                .dept-btn-apply:hover {
                    background-color: #243d60;
                    color: #fff;
                }

                /* RESET — light pink/salmon fill like Image 2 */
                .dept-btn-reset {
                    background-color: #fde8e8;
                    color: #c0392b;
                    border: 1px solid #f5c6cb;
                    border-radius: 6px;
                    padding: 8px 20px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    letter-spacing: 0.4px;
                    transition: all 0.2s;
                    white-space: nowrap;
                }

                .dept-btn-reset:hover {
                    background-color: #f8d7da;
                    border-color: #f1aeb5;
                    color: #a52834;
                }

                /* ---- Responsive ---- */
                @media (max-width: 600px) {
                    .dept-page-header,
                    .dept-filter-row {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .dept-search-group {
                        max-width: 100%;
                    }

                    .dept-page-subtitle {
                        white-space: normal;
                    }
                }
            `}</style>
        </>
    );
};

export default Departments;